import MatomoMessage from '@/matomo/message/MatomoMessage';
import {
  CartItem
} from '@/services/cart/model/cart';
import Big from 'big.js';
import { MatomoActions } from '@/matomo/MatomoActions';
import PriceService from '@/services/PriceService';

export default class MatomoRefreshCart {
  private ecommerceItemMessages: MatomoMessage[];
  private trackingUpdate: MatomoMessage;

  private constructor(ecommerceItemMessages: MatomoMessage[], trackingUpdate: MatomoMessage) {
    this.ecommerceItemMessages = ecommerceItemMessages;
    this.trackingUpdate = trackingUpdate;
  }

  public static from(cartItems: CartItem[], cartTotal: Big): MatomoRefreshCart {
    return new MatomoRefreshCart(
      this.findEcommerceItemMessages(cartItems),
      this.toTrackingUpdateMessage(cartTotal)
    );
  }

  private static findEcommerceItemMessages(cartItems: CartItem[]): MatomoMessage[] {
    return cartItems.map((el) => this.toEcommerceItemMessage(el));
  }

  private static toEcommerceItemMessage(cartItem: CartItem): MatomoMessage {
    return new MatomoMessage([
      MatomoActions.addEcommerceItem,
      cartItem.sku,
      cartItem.product.name,
      cartItem.product.resolvedCategory.name,
      this.findBestPrice(cartItem),
      cartItem.amount
    ]);
  }

  private static findBestPrice(cartItem: CartItem): string | null {
    const bestPriceDto = PriceService.findBestBulkPrice(cartItem.product.bulkPrices, cartItem.amount, cartItem.unit);

    if (bestPriceDto) {
      return bestPriceDto.rawValueString;
    }

    return null;
  }

  private static toTrackingUpdateMessage(cartTotal: Big): MatomoMessage {
    return new MatomoMessage([
      MatomoActions.trackEcommerceCartUpdate,
      cartTotal.toString()
    ]);
  }

  public publish() {
    this.ecommerceItemMessages.forEach((el) => el.publish());
    this.trackingUpdate.publish();
  }
}
